import { normalizeString } from './normalizeString'

export const filterRows = ({ filterByTerm, rows, defineRows }) => {
  if (filterByTerm.length <= 0) {
    defineRows(rows)
    return
  }

  const filteredRows = rows.filter(row => {
    return normalizeString({ term: row.employee }).includes(
      normalizeString({ term: filterByTerm }),
    )
  })

  defineRows(filteredRows)
}
